import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAlertCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={17} viewBox="0 0 16 17" fill="none" {...props}>
    <path fill="#E4002B" fillRule="evenodd" d="M8 16.5C12.4183 16.5 16 12.9183 16 8.5C16 4.08172 12.4183 0.5 8 0.5C3.58172 0.5 0 4.08172 0 8.5C0 12.9183 3.58172 16.5 8 16.5ZM7 9.5V3.5H9V9.5H7ZM7 13.5V11.5H9V13.5H7Z" clipRule="evenodd" />
  </svg>
);
export default SvgAlertCircle;
